import { PublicType } from '@Shared.Angular/@types/core/contracts/constants/publicType';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';

angular
  .module('flowingly.runner.library')
  .controller(
    'procedureSharingDialogController',
    procedureSharingDialogController
  );

procedureSharingDialogController.$inject = ['$scope'];

function procedureSharingDialogController($scope: IScopeNgDialog) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const ctrl = this as {
    procedureName: string;
    initialPublicType: PublicType | null;
    publicType: PublicType | null;
    publicShareableUrl: string;
    iframeTag: string;
    save: () => void;
    cancel: () => void;
    onPublicTypeChange: (value: PublicType | null) => void;
  };
  ctrl.procedureName = $scope.ngDialogData.procedureName;
  ctrl.initialPublicType = $scope.ngDialogData.procedurePublicType;
  ctrl.publicType = $scope.ngDialogData.procedurePublicType;
  ctrl.publicShareableUrl = `${window.location.origin}/sop/${$scope.ngDialogData.procedureId}`;
  ctrl.iframeTag = `<iframe width="650" height="800" src="${ctrl.publicShareableUrl}" frameborder="0"></iframe>`;

  ctrl.save = () => {
    $scope.closeThisDialog({
      id: $scope.ngDialogData.procedureId,
      publicType: ctrl.publicType
    } as IProcedureSharingResult);
  };

  ctrl.cancel = () => {
    $scope.closeThisDialog();
  };

  ctrl.onPublicTypeChange = (value: PublicType | null) => {
    ctrl.publicType = value;
  };
}

export interface IProcedureSharingResult {
  id: Guid;
  publicType: PublicType | null;
}
